export const GET_HISTORY = 'GET_HISTORY';
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS';


export const GET_STAFF_HISTORY = 'GET_STAFF_HISTORY';
export const GET_STAFF_HISTORY_SUCCESS = 'GET_STAFF_HISTORY_SUCCESS';